import React from 'react';
import styled from 'styled-components';

const TabStyle = styled.div`
  flex: 1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  -webkit-user-select: none;  
  -moz-user-select: none;    
  -ms-user-select: none;      
  user-select: none;
  
  .cont {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;

    svg {
      font-size: var(--font-size-lg);
      fill: #667085;
      transition: .3s fill;
    }
  }

  .main-c {
    display: flex;
    justify-content: center;
    gap: 8px;

    label {
      font-size: 18px;
      margin-bottom: 0px;
      cursor: pointer;
      transition: .3s color;
      color: #667085;
      font-weight: 400 !important;
    }

    svg {
      fill: #667085;
    }
  }

  &.active {
    .main-c {
      label { 
        color: var(--color-primary-70);
      }

      svg {
        fill: var(--color-primary-70);
      }
    }
  }
`;

const TabStake = ({
  config = { icon: '', label: '' },
  t = (s) => s,
  isActive = false,
}) => (
  <TabStyle className={isActive ? 'active' : 'disabled'}>
    <div className="main-c">
      <div className="cont">
        {config.icon}
      </div>
      <div className="cont">
        <label>{t(config.label)}</label>
      </div>
    </div>
  </TabStyle>
);

export default TabStake;
